<template>
  <div>
    <condition-part
      :hasDate="true"
      :hasEmployee="true"
      :hasFoodKind="true"
      :hasFood="true"
      :hasCustomer="true"
      :hasCostType="true"
      :hasExcel="true"
      :hasPdf="true"
      :hasAdd="false"
      :hasEdit="false"
      :hasRemove="false"
      :columns="columns"
      :items="items"
      :pagination="pagination"
      :isSortable="true"
      @getItems="getItems"
      @downloadExcel="downloadExcel"
      @downloadPdf="downloadPdf"
      @printPdf="printPdf"
    >
      <div class="row" v-if="chartData.rows.length > 0" slot="middleArea">
        <div class="col-md-6">
          <div class="card card-table card-body">
            <ve-histogram :data="chartData" :settings="chartSettings" />
          </div>
        </div>
        <div class="col-md-6">
          <div class="card card-table card-body">
            <ve-pie :data="chartData"></ve-pie>
          </div>
        </div>
      </div>
    </condition-part>
  </div>
</template>

<script>
import conditionPart from "@/components/parts/conditionPart";

export default {
  data() {
    return {
      items: [],
      pagination: {},
      chartSettings: {
        labelMap: {
          Qty: "數量",
          Total: "金額",
        },
        axisSite: { right: ["Total"] },
        yAxisType: ["normal", "KMB"],
        yAxisName: ["數量", "金額"],
      },
      chartData: {
        columns: ["FoodName", "Qty", "Total"],
        rows: [],
      },
    };
  },
  computed: {
    columns() {
      return [
        { name: "CustomerNumber" },
        { name: "CustomerName" },
        { name: "FoodKindNumber" },
        { name: "FoodKindName" },
        { name: "FoodNumber" },
        { name: "FoodName" },
        { name: "Qty" },
        { name: "Total" },
        { name: "Unit" },
      ];
    },
  },
  components: {
    conditionPart,
  },
  methods: {
    downloadExcel(condition) {
      this.$api.reportExcels.getCustomerFree(condition);
    },
    downloadPdf(condition) {
      this.$api.reportPdfs.getCustomerFree(condition);
    },
    printPdf(condition) {
      this.$api.reportPdfs.printCustomerFree(condition);
    },
    getItems(condition) {
      const vm = this;
      this.$api.reports.getCustomerFree(condition).then((data) => {
        vm.items = data.Datas;
        vm.pagination = data.Pagination;
        vm.chartData.rows = data.Datas;
      });
    },
  },
};
</script>
